




























import { Vue, Component } from "vue-property-decorator";
import History from "@/components/History.vue";
import Products from "@/components/Products.vue";
import Axios from "axios";
import store from "../store";

@Component({ components: { History, Products } })
export default class Dash extends Vue {
  xmls = [];

  beforeCreate() {
    Axios.get(`https://api.clubdobalanco.com/v1/reports`, {
      headers: { Authorization: store.state.passwd }
    }).then(r => (this.xmls = r.data));
  }
}
